var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"label":_vm.$t('inputs.chooseAppearanceConstrain.label'),"items":[{text: 'BLACKLIST'},{text: 'WHITELIST'}],"item-value":"text","rules":_vm.rules,"append-icon":"fa fa-location-arrow"},model:{value:(_vm.constrain),callback:function ($$v) {_vm.constrain=$$v},expression:"constrain"}})
}
var staticRenderFns = []

export { render, staticRenderFns }